import { TableHead, TableHeadCell, TableHeadRow } from 'components';

export const RecentCustomersOrdersHead = () => (
  <TableHead>
    <TableHeadRow>
      <TableHeadCell>Order No.</TableHeadCell>
      <TableHeadCell>Order date</TableHeadCell>
      <TableHeadCell>Reference number</TableHeadCell>
      <TableHeadCell>Customer</TableHeadCell>
      <TableHeadCell />
    </TableHeadRow>
  </TableHead>
);
